import FirmModel from './firm.model';

export default class FirmSettingModel {
  public firms: FirmModel[];
  public totalCount: number;
  public constructor() {}
}
